import React from 'react';
import { TouchableOpacity, StyleSheet, Vibration, ImageBackground, Dimensions, LayoutAnimation, Platform } from 'react-native';

import * as ImagePicker from 'expo-image-picker';
import * as FileSystem from 'expo-file-system';
import * as ImageManipulator from 'expo-image-manipulator';
import { Camera } from 'expo-camera';
//import { Camera } from 'react-native-camera';
import * as Permissions from 'expo-permissions';
import Modal from '../../components/modal';
import GalleryScreen from './GalleryScreen';
//import RNTextDetector from 'react-native-text-detector';
import Alert from '../../components/alert';

import * as _ from 'lodash';
//import FindFigures from './findFigures';
import { Container, Header, InputGroup, Content, Text, Label, Picker, Item, Card, CardItem, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, Footer } from 'native-base';

const deviceWidth = Dimensions.get('window').width;
const deviceHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
	modalStyle: {
		borderRadius: 10,
		alignSelf: 'center',
		justifyContent: 'center',
		width: Math.min((deviceHeight * 0.9 - 45) / 1.7, deviceWidth - 28),
		height: '90%',
		marginHorizontal: 14 //negates the effect of the header on aspect ratio
	},
	modalContainer: {
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: '#f8f8fc'
	},
	innerContainer: {
		flex: 1
		//alignItems: 'center',
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},
	imageBackground: {
		//	position: 'absolute',
		flex: 1,

		alignItems: 'center',
		justifyContent: 'flex-end',
		backgroundColor: 'black'
		//top: 0,
		//left: 0
	},
	boundingRect: {
		position: 'absolute',
		alignItems: 'center',
		justifyContent: 'center',
		borderWidth: 2
	},
	bottomButtons: {
		backgroundColor: 'rgba(52, 52, 52, 0.8)',
		flexDirection: 'row',
		alignItems: 'center'
	},
	bottomIconBtn: { flex: 1, alignItems: 'center' }
});

const DESIRED_RATIO = '16:9';

export default class DECamera extends React.Component {
	constructor(props: IProps) {
		super(props);
		this.state = {
			hasCameraPermission: null,
			type: Camera.Constants.Type.back,
			photoId: 1,
			showGallery: false,
			autoFocus: Camera.Constants.AutoFocus.on,
			image: null,
			error: null,
			total: null,
			totalId: null,
			biggestId: null,
			date: null,
			visionResp: [],
			loading: false,
			ratio: DESIRED_RATIO,
			ratios: [],
			textBlocks: []
		};
	}

	componentDidMount() {
		/*FileSystem.makeDirectoryAsync(FileSystem.documentDirectory + 'photos').catch(e => {
			console.log(e, 'Directory exists');
		});
	*/
		this.askPermissions(this.props.autoPermissions);
		Dimensions.addEventListener('change', () => {
			this.setState({ ratio: DESIRED_RATIO, ratios: [] });
		});
	}
	componentDidUpdate(prevProps, prevState) {
		if (!this.props.navigation) return;
		const { isDrawerOpen } = this.props.navigation.state;
		const wasDrawerOpen = prevProps.navigation.state.isDrawerOpen;
		if (isDrawerOpen == wasDrawerOpen) return;
		if (isDrawerOpen) {
			this.camera && this.camera.resumePreview();
			console.log('sidecam on');
		} else {
			this.camera && this.camera.pausePreview();
			console.log('sidecam off');
		}
	}

	async askPermissions(ask) {
		let asked;
		if (ask) asked = await Permissions.askAsync(Permissions.CAMERA);
		__DEV__ && console.log(asked);
		const { status } = await Permissions.getAsync(Permissions.CAMERA);
		this.setState({ hasCameraPermission: status === 'granted' });
	}

	async toggleView() {
		//from galleryscreen
		const hasCamRollPerms = Platform.OS === 'android' || (await Permissions.getAsync(Permissions.CAMERA_ROLL));
		console.log('has camroll', hasCamRollPerms);
		if (Platform.OS === 'ios' && hasCamRollPerms.status != 'granted') await Permissions.askAsync(Permissions.CAMERA_ROLL);
		const pickedImage = await ImagePicker.launchImageLibraryAsync({ mediaTypes: ImagePicker.MediaTypeOptions.Images, allowsEditing: true });
		if (!pickedImage.cancelled) this.scanPicture(pickedImage);
		/*
		this.setState({
			showGallery: !this.state.showGallery
		});*/
	}

	getRatios = async () => {
		if (Platform.OS === 'android' && this.camera && !this.state.ratios.length) {
			console.log('getting ratios');

			const ratios = await this.camera.getSupportedRatiosAsync();
			__DEV__ && console.log(ratios);
			//Sentry.captureException(new Error(ratios));
			const ratio = ratios.find(ratio => ratio === DESIRED_RATIO) || ratios[ratios.length - 1];

			this.setState({ ratios, ratio });
		}
	};

	resize = async (url: string) => {
		__DEV__ && console.log('manipulating', url);
		const manipResult = await ImageManipulator.manipulateAsync(url, [{ resize: { height: 1200 } }], { format: 'jpeg', compress: 0.6, base64: true });
		return manipResult.base64;
	};
	/*
	takePicture = async function() {
		if (this.camera) {
			//this.setState({autoFocus:Camera.Constants.AutoFocus.off});
			const saveTo = `${FileSystem.documentDirectory}photos/Photo${Math.random() * 1000}.jpg`;
			console.log('saving to', saveTo);
			//this.camera.pausePreview();
			this.camera.takePictureAsync({ quality: 0.6, base64: false }).then(data => {
				console.log('taken pic');
				FileSystem.moveAsync({
					from: data.uri,
					to: saveTo
				}).then(() => {
					Vibration.vibrate();
					this.resize(saveTo).then(res => this.props.closure(res, data));
				});
			});
		}
	};
*/
	reset(error = 'OTHER') {
		//FileSystem.deleteAsync(this.state.image, { idempotent: true });
		this.setState(
			{
				loading: false,
				image: null,
				visionResp: [],
				error
			},
			() => {
				// setTimeout(() => this.camera.startPreview(), 500);
			}
		);
	}

	savePic() {
		const { image, total, date } = this.state;
		var dat = null;
		if (date) {
			splDate = date.split('/');
			dat = `${splDate[2]}-${splDate[1]}-${splDate[0]}`;
		}

		this.resize(image).then(res => {
			//FileSystem.deleteAsync(image, { idempotent: true });
			this.props.closure && this.props.closure(res, { total, date: dat });
			//or we are in drawer... navigate to Entry with new wotsit
			if (!this.props.closure) {
				this.props.navigation.navigate('Entry', {
					addTrans: 'expense',
					addDate: dat,
					total,
					pic: res
				});
				this.reset();
			}
		});
	}

	async scanPicture(data) {
		console.log('taking pic');
		if (!data) data = await this.camera.takePictureAsync(PICTURE_OPTIONS);
		const PICTURE_OPTIONS = {
			quality: 0.8,
			fixOrientation: true,
			forceUpOrientation: true,
			skipProcessing: true,
			base64: false
		};
		if (!data.uri) {
			throw 'OTHER';
		}
		this.setState(
			{
				image: data.uri
			},
			() => {
				//fires after updated
				__DEV__ && console.log(data.uri);

				setTimeout(() => {
					LayoutAnimation.configureNext(LayoutAnimation.Presets.linear);
					this.setState({ loading: true }, async function () {});
				}, 100);
			}
		);

		try {
			console.log('taking pic tries');
			this.processImage(data.uri, {
				height: data.height,
				width: data.width
			});
		} catch (e) {
			console.warn(e);
			this.reset(e);
		}
	}

	processImage = async (uri, imageProperties) => {
		this.setState({
			visionResp: [],
			total: 0,
			totalId: 0,
			biggestId: 0,
			date: null
		});
	};

	mapVisionRespToScreen = (visionResp, imageProperties) => {
		/*const wi= imageProperties.width, hi=imageProperties.height, ws=this.picWidth, hs=this.picHeight;
		const ri = wi / hi ;
		const rs = ws / hs;
		const IMAGE_TO_SCREEN_X = rs > ri ? wi * hs/hi : ws;
		const IMAGE_TO_SCREEN_Y = rs > ri ? hs : hi * ws/wi;*/

		const IMAGE_TO_SCREEN_Y = this.picHeight / imageProperties.height;
		const IMAGE_TO_SCREEN_X = this.picWidth / imageProperties.width;

		return visionResp.map(item => {
			return {
				...item,
				position: {
					width: item.bounding.width * IMAGE_TO_SCREEN_X,
					left: item.bounding.left * IMAGE_TO_SCREEN_X,
					height: item.bounding.height * IMAGE_TO_SCREEN_Y,
					top: item.bounding.top * IMAGE_TO_SCREEN_Y
				}
			};
		});
	};

	findFigures(txts) {
		/*   return boxes with some marked as total/VAT
			others will be presented in grey
		//first, find the word Total. Figure just under or to right of that!?
		//find biggest number!! First split but \n
		*/
		splitBoxes = [];
		nid = 0;
		dt = null;
		txts.forEach(e => {
			if (e.blockText) sp = e.blockText.split(/\n/);

			var children = sp.map((line, i, lines) => {
				nid++;
				d = line.match(/\d{1,2}\/\d{1,2}\/\d{2,4}/);
				if (d) dt = d[0]; //date!
				//console.log(line, e.blockCoordinates);
				return {
					text: line,
					id: nid,
					area: ((e.blockCoordinates.width / 2) * (e.blockCoordinates.height * 2)) / lines.length, //biased to height!
					num: (line.search(/^\w{0,4}[£$]?\s*\d+[\.,]\d+\s*\w{0,4}$/i) > -1 && parseFloat(line.replace(/[A-Za-z£$]/g, '').replace(',', '.'))) || 0,
					bounding: {
						left: e.blockCoordinates.left,
						width: e.blockCoordinates.width,
						height: e.blockCoordinates.height / lines.length,
						top: e.blockCoordinates.top + (e.blockCoordinates.height / lines.length) * i
					}
				};
			});
			splitBoxes.push(...children);
		});

		//get biggest number
		splitBoxes = _.sortBy(splitBoxes, ['num']);
		const { id, num } = splitBoxes[splitBoxes.length - 1];

		//get largest text
		biggestText = _.sortBy(splitBoxes, ['area'])[splitBoxes.length - 1].text;
		__DEV__ && console.log(biggestText, dt);

		return { importantBoxes: splitBoxes, totalId: id, total: num.toFixed(2), date: dt, biggestText };
	}

	selectText(id, item) {
		//if clicked a non-number, give it a chance!
		var num = item.num || parseFloat(item.text.replace(/[A-Za-z£$]/g, '')) || 0;
		this.setState({ totalId: id, total: num.toFixed(2) });
	}

	pressTotal() {
		Alert.alert('Incorrect?', 'Tap on the total if this is wrong');
	}

	async laidBox(event) {
		var { x, y, width, height } = event.nativeEvent.layout;
		this.picWidth = width;
		this.picHeight = height;
		//const layouts = await this.camera.getAvailablePictureSizesAsync((width / height).toFixed(4));
		//console.log('laid out cam box');
		//console.log(layouts);
	}

	/*

RENDERS


*/

	renderNoPermissions() {
		return (
			<View>
				<Text style={{ textAlign: 'center', padding: 5 }}>You can scan your expense receipts - save them to CalCal and auto-fill some figures.</Text>
				<Button style={{ alignSelf: 'center' }} onPress={() => this.askPermissions(true)}>
					<Text>Use my camera</Text>
				</Button>
			</View>
		);
	}

	renderGallery() {
		return <GalleryScreen onPress={this.toggleView.bind(this)} />;
	}

	renderBoxes() {
		const { hasCameraPermission, totalId, total, biggestId, showGallery, loading } = this.state;
		return (
			<ImageBackground source={{ uri: this.state.image }} style={styles.imageBackground} key="image" resizeMode="cover">
				{this.state.visionResp.map(item => {
					var borderColor = item.id == totalId ? '#FF6600' : item.num ? '#555' : '#999';
					if (item.id == biggestId) borderColor = '#005500';
					return <TouchableOpacity onPress={() => this.selectText(item.id, item)} style={[styles.boundingRect, item.position, { borderColor }]} key={`${item.text}${item.position.top}`} />;
				})}
				<View style={styles.bottomButtons}>
					<TouchableOpacity
						style={styles.bottomIconBtn}
						onPress={() => {
							this.reset();
						}}>
						<Icon name="arrow-back" style={{ color: '#BBB', fontSize: 34 }} />
					</TouchableOpacity>
					<TouchableOpacity
						style={styles.bottomIconBtn}
						onPress={() => {
							this.pressTotal();
						}}>
						<Text style={{ color: 'white' }}>{total && `£ ${total}`}</Text>
					</TouchableOpacity>
					<TouchableOpacity disabled={!this.state.visionResp} style={styles.bottomIconBtn} onPress={() => this.savePic()}>
						<Icon name="checkmark" style={{ color: 'white', fontSize: 44 }} />
					</TouchableOpacity>
				</View>
				<View style={{ backgroundColor: 'rgba(255,255,255,0.8)', width: '100%', height: 3, top: !!loading ? this.picHeight : 0, position: 'absolute' }} />
			</ImageBackground>
		);
	}

	render() {
		const { hasCameraPermission, totalId, total, biggestId, showGallery, loading } = this.state;
		const cameraScreenContent = hasCameraPermission ? this.renderCamera(loading) : this.renderNoPermissions();
		var content = null;
		if (showGallery) {
			content = this.renderGallery();
		} else {
			content = !this.state.image ? cameraScreenContent : this.renderBoxes();
		}
		//if (this.props.navigation && this.props.navigation.state && !this.props.navigation.state.isDrawerOpen) content = <View style={{ backgroundColor: 'black', flex: 1 }} />;

		if (!this.props.closure)
			//in right drawer
			return (
				<View style={{ flex: 1 }}>
					<Header style={{ height: 45 }}>
						<Left>
							<Icon name="camera" style={{ color: 'white' }} />
						</Left>
						<Body>
							<Title>Receipt Scanner</Title>
						</Body>
						<Right />
					</Header>
					<View style={{ flex: 1 }} onLayout={event => this.laidBox(event)}>
						{content}
					</View>
				</View>
			);
		//modal
		return (
			<Modal isOpen={true} backButtonClose coverScreen swipeThreshold={100} style={styles.modalStyle} onClosed={() => this.props.closure(false)}>
				<Header style={styles.modalHeader}>
					<Left>
						<Icon name="camera" style={{ color: 'white' }} />
					</Left>
					<Body>
						<Title>Your receipt</Title>
					</Body>
				</Header>

				<View style={styles.modalContainer}>
					<View style={styles.innerContainer}>
						<View
							style={{ flex: 1 }}
							onLayout={event => {
								var { x, y, width, height } = event.nativeEvent.layout;
								this.picWidth = width;
								this.picHeight = height;
							}}>
							{content}
						</View>
					</View>
				</View>
			</Modal>
		);
	}

	textRecognized = object => {
		const { textBlocks } = object;
		this.setState({ textBlocks });
	};

	renderCamera() {
		//certainly have permissions
		const { loading, ratios } = this.state;

		//if (!ratios.length) this.getRatios();
		//if (!this.state.picSize) return null;
		return (
			<Camera
				style={{ flex: 1 }}
				ref={ref => {
					this.camera = ref;
				}}
				type={this.state.type}
				ratio={this.state.ratio}
				//pictureSize={this.state.picSize}
				/*onCameraReady={g => {
					g && g.pausePreview();
				}}*/
				onCameraReady={this.getRatios}
				autoFocus={this.state.autoFocus}
				//captureAudio={false}
			>
				<View
					style={{
						flex: 1
					}}
				/>
				<View style={styles.bottomButtons}>
					<TouchableOpacity
						style={styles.bottomIconBtn}
						onPress={() => {
							this.setState({
								type: this.state.type === Camera.Constants.Type.back ? Camera.Constants.Type.front : Camera.Constants.Type.back
							});
						}}>
						<Icon name="reverse-camera" style={{ color: '#DDD', fontSize: 24 }} />
					</TouchableOpacity>
					<TouchableOpacity
						style={styles.bottomIconBtn}
						onPress={() => {
							this.toggleView();
						}}>
						<Icon name="image" style={{ color: '#BBB', fontSize: 34 }} />
					</TouchableOpacity>
					<TouchableOpacity
						style={styles.bottomIconBtn}
						onPress={() => {
							this.scanPicture();
						}}>
						<Icon name="camera" style={{ color: 'white', fontSize: 44 }} />
					</TouchableOpacity>
				</View>
			</Camera>
		);
	}
}
